var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVakif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#22262F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_940_1335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3007 15.7266C29.5717 14.1692 28.1447 12 24.249 12H14.5734C11.9218 12 10.2564 13.8257 9.96255 15.6611L8 26C9.72417 25.9967 21.0782 26 21.0554 26H21.7934C25.8589 25.9771 28.2002 25.061 28.628 22.1066C28.9121 20.1173 27.1683 18.8315 25.7413 18.5599C27.1814 18.2982 28.9349 17.8042 29.2974 15.7298",
    fill: "#FBBA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 16.3319C19.2267 17.585 15.6412 21.93 14.913 22.7545C13.2934 24.5998 9.95279 24.3249 9.92993 24.2791C9.92993 24.2791 11.1349 18.5731 11.5235 16.9634C12.5978 12.589 16.2911 13.6229 16.2911 13.6229C16.2911 13.6229 15.3082 13.7636 14.6126 14.6535C13.9073 15.5533 13.1105 19.9375 12.6599 21.9856C14.7759 19.5088 17.6756 16.3123 18.1687 15.7136C20.2782 13.1583 23.5763 13.5084 23.5763 13.5084C23.5763 13.5084 22.2897 13.6883 20.2162 16.3287",
    fill: "#22262F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_940_1335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 14,
    fill: "white",
    transform: "translate(8 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVakif);
export default __webpack_public_path__ + "static/media/vakif.988e96d55bf34d35ba03c100f284b845.svg";
export { ForwardRef as ReactComponent };